import React, { useRef } from "react";
import { Form } from "react-bootstrap";

const MultiFileUploadInput = ({ label, name, required = false, formik }) => {
  const fileInputRef = useRef(null);
  const files = formik.values[name] || [];

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.currentTarget.files);
    formik.setFieldValue(name, [...files, ...selectedFiles]);
  };

  const handleRemove = (indexToRemove) => {
    const updatedFiles = files.filter((_, index) => index !== indexToRemove);
    formik.setFieldValue(name, updatedFiles);
  };

  const triggerFileDialog = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="mb-4">
      <Form.Label>{label}</Form.Label>

      <div className="position-relative">
        <div
          className="d-flex flex-column border rounded px-3 py-2"
          style={{
            backgroundColor: "#f9f9f9",
            borderColor: "#ced4da",
            position: "relative",
            zIndex: 1,
            cursor: "pointer",
          }}
          onClick={triggerFileDialog}
        >
          <Form.Control
            type="file"
            name={name}
            onChange={handleFileChange}
            onBlur={formik.handleBlur}
            isInvalid={!!formik.errors[name] && formik.touched[name]}
            style={{ display: "none" }}
            ref={fileInputRef}
            multiple
          />

          {/* File list or placeholder */}
          {files.length === 0 ? (
            <span className="text-muted" style={{ fontSize: "13px" }}>
              Upload Documents
            </span>
          ) : (
            <ul className="mb-0" style={{ listStyle: "none", paddingLeft: 0 }}>
              {files.map((file, index) => (
                <li
                  key={index}
                  className="d-flex justify-content-between align-items-center py-1"
                >
                  <span style={{ fontSize: "13px" }}>{file.name}</span>
                  <i
                    className="bi bi-x-lg text-danger"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemove(index);
                    }}
                  ></i>
                </li>
              ))}
            </ul>
          )}
        </div>

        <Form.Control.Feedback type="invalid">
          {formik.errors[name]}
        </Form.Control.Feedback>
      </div>
    </div>
  );
};

export default MultiFileUploadInput;
